export default {"src":"/_next/static/media/hide-small-icon.5890ba53.svg","height":11,"width":14};